import { render, staticRenderFns } from "./SidebarTemplate.vue?vue&type=template&id=30caf6e4&scoped=true"
import script from "./SidebarTemplate.vue?vue&type=script&lang=js"
export * from "./SidebarTemplate.vue?vue&type=script&lang=js"
import style0 from "./SidebarTemplate.vue?vue&type=style&index=0&id=30caf6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30caf6e4",
  null
  
)

export default component.exports